import styled, { css } from 'styled-components'
import { Section as BaseSection } from '../common/styles'
import { desktopBreakpoint } from 'react-components'

export const Section = styled(BaseSection)(
    ({ theme }) => css`
        @media only screen and (max-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xSmall};
        }
    `,
)

export const Title = styled.h2`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: 1.5rem;
    font-weight: ${({ theme }) => theme.typography.font.weight.bold};
    margin-bottom: 1.5rem;
    color: #282828;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 2rem;
    }
`

export const FaqList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const FaqItem = styled.div`
    border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.tfwBlackOpacity10};
`

export const QuestionButton = styled.button`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    transition: all 0.3s ease;

    &:hover {
        opacity: 0.8;
    }
`

export const Question = styled.h3`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: 1rem;
    font-weight: ${({ theme }) => theme.typography.font.weight.semiBold};
    color: ${({ theme }) => theme.colors.tfwBlack87};
    margin: 0;
    flex: 1;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-weight: ${({ theme }) => theme.typography.font.weight.normal};
        font-size: 1rem;
        line-height: 1.5rem;
        vertical-align: middle;
    }
`

export const IconWrapper = styled.span<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.tfwBlack87};
`

export const AnswerWrapper = styled.div<{ isOpen: boolean }>`
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
`

export const AnswerContent = styled.div`
    min-height: 0;
`
